<template>
  <ValidationProvider
    ref="validationProvider"
    v-slot="{ errors, valid, dirty, failedRules, touched, invalid }"
    :bails="bails"
    :immediate="immediateValidation"
    :name="name || label.toLowerCase()"
    :rules="validationRules"
    :vid="vid"
  >
    <b-form-group :id="`${name}-input-group`" :label-for="$attrs.id">
      <div class="d-flex justify-content-between align-items-baseline">
        <slot name="label" :props="$props">
          <label v-if="label" class="input-label" :class="labelClass ? labelClass : 'text-dark'" :for="$attrs.id">
            {{ label }}
          </label>
        </slot>
        <b-form-text v-if="isPasswordType && value">
          <b-link @click="toggleShowPassword">
            {{ showPassword ? $t('input.password.buttonText.hide') : $t('input.password.buttonText.show') }}
          </b-link>
        </b-form-text>
        <b-form-text v-else-if="formText">
          {{ formText }}
        </b-form-text>
      </div>
      <b-form-input
        v-model="field"
        v-bind="$attrs"
        :name="name"
        :class="validationState == 'valid' ? valid : (touched && invalid) || (invalidClass && invalid) ? 'is-invalid' : ''"
        :state="validationState == 'valid' ? valid : dirty && (errors[0] || invalid) ? false : null"
        :type="showPassword ? 'text' : type"
        @blur="onBlurEvent"
        @focus="onFocusEvent"
      />
      <slot name="sub-text" />
      <i18n v-if="_.get(errors[0], 'path', false)" :path="errors[0].path" tag="div" class="invalid-feedback">
        <template #br>
          <br />
        </template>
        <template #action>
          <b-link :to="_.get(errors[0], 'action.to', null)" class="font-weight-bold">
            {{ _.get(errors[0], 'action.text', '') }}
          </b-link>
        </template>
      </i18n>
      <div v-else class="invalid-feedback">
        {{ errors[0] }}
      </div>
      <slot :failedRules="failedRules" :dirty="dirty" :valid="valid" />
    </b-form-group>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'DpInput',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    bails: {
      type: Boolean,
      default: true,
    },
    validationState: {
      type: [Boolean, String],
      default: null,
    },
    validationErrors: {
      type: [String, Object],
      default: '',
    },
    validationRules: {
      type: [String, Object],
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    invalidClass: {
      type: Boolean,
      default: false,
    },
    formText: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    immediateValidation: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    showPassword: false,
  }),
  computed: {
    field: {
      get: ({ value } = this) => value,
      set(value) {
        this.$emit('input', value);
      },
    },
    isPasswordType: (self = this) => self.type.toLowerCase() === 'password',
  },
  watch: {
    validationErrors: function (value) {
      if (value) this.$refs.validationProvider.errors.push(value);
    },
  },
  methods: {
    onBlurEvent() {
      if (this.type.toLowerCase() === 'password') this.showPassword = false;
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    onFocusEvent() {
      this.$emit('focus');
    },
  },
};
</script>

<style scoped>
.bounce {
  animation-name: bounce;
  animation-duration: 0.5s;
  animation-delay: 0.25s;
}

@keyframes bounce {
  0% {
    transform: translateX(0px);
    timing-function: ease-in;
  }
  37% {
    transform: translateX(5px);
    timing-function: ease-out;
  }
  55% {
    transform: translateX(-5px);
    timing-function: ease-in;
  }
  73% {
    transform: translateX(4px);
    timing-function: ease-out;
  }
  82% {
    transform: translateX(-4px);
    timing-function: ease-in;
  }
  91% {
    transform: translateX(2px);
    timing-function: ease-out;
  }
  96% {
    transform: translateX(-2px);
    timing-function: ease-in;
  }
  100% {
    transform: translateX(0px);
    timing-function: ease-in;
  }
}
</style>
